// import Monogram from "@/components/ui/icons/monogram";
// import { zoomOut } from "@/utils/motion/zoom-out";
// import useScrollLock from "@/utils/use-scroll-lock";
// import cn from "classnames";
// import { useUI } from "@/contexts/ui.context";
// import Partners from "@/components/pages/home/partners";
// import ChalkTv from "@/components/pages/home/chalk-tv";
// import News from "@/components/pages/about/news";
// import RelatedPosts from "@/components/pages/blog/related-posts";
//import { HOME_TEXT_QUERY } from "@/framework/queries/homeText";
// import { slideUp } from "@/utils/motion/slide-up";
// import { AnimatePresence, m } from "framer-motion";

import dynamic from "next/dynamic";
import Banner from "@/components/pages/home/banner";
import { getUrqlClient } from "@/lib/urql-client";
import { sanitize } from "@/framework/utils/sanitize";
import { QUERY_ALL_CLIENTS } from "@/framework/queries/clients";
import { QUERY_ALL_HOME_SLIDER } from "@/framework/queries/home-slider";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { HEADER_AND_TEXT_QUERY } from "@/framework/queries/header_and_text";
import Seo from "@/utils/seo";

const About = dynamic(() => import("@/components/pages/home/about"), { ssr: false });
const News = dynamic(() => import("@/components/pages/about/news"), { ssr: false });
const Partners = dynamic(() => import("@/components/pages/home/partners"), { ssr: false });
const ChalkTv = dynamic(() => import("@/components/pages/home/chalk-tv"), { ssr: false });
const seo = {
    slug: "",
    metaTitle: "Interior Designing Firm | Interior Design Studio",
    metaDescription:
        "Chalk Studio is an interior design firm provides tailored interior design solutions for residential and commercial spaces.",
};

export default function Home({ clients, slider, press, homeText }) {
    return (
        <>
            <Seo seo={seo} />
            {/* <AnimatePresence mode="sync"> */}
            {/* <m.div
                        initial="from"
                        // whileInView={!loader ? "to" : "from"}
                        whileInView={ "to" }
                        viewport={{ once: true }}
                        variants={slideUp()}
                        id="mainContent"
                    > */}
            <Banner data={slider} />
            <About homeText={homeText} />
            <News press={press} title="Press & Media" />
            <Partners clients={clients} />
            <ChalkTv />
            {/* </m.div> */}
            {/* </AnimatePresence> */}
        </>
    );
}

export async function getStaticProps() {
    const client = await getUrqlClient();
    let press = [];
    let clients = [];
    let homeText = {};
    let slider = [];

    try {
        const [pressResponse, sliderResponse, clientResponse, homeTextResponse] = await Promise.all([
            client.query(QUERY_ENDPOINTS.QUERY_ALL_PRESS, {
                start: 0,
                limit: 10, // Limit to fewer items if possible
                sortBy: ["id:asc"],
                filter: {}, // Ensure only required fields are fetched
            }, { requestPolicy: "network-only" }),

            client.query(QUERY_ALL_HOME_SLIDER, { requestPolicy: "network-only" }),

            client.query(QUERY_ALL_CLIENTS, {
                start: 0,
                limit: 40, // Limit to fewer items if possible
                sort: ["order:asc"],
                filters: {}, // Ensure only required fields are fetched
            }, { requestPolicy: "network-only" }),

            client.query(HEADER_AND_TEXT_QUERY, {
                start: 0,
                limit: 1, // Only need the first result
                sort: ["order:asc"],
                filters: {
                    for: { eq: "Home" },
                    order: { eq: 1 },
                },
            }, { requestPolicy: "cache-and-network" }),
        ]);

        press = pressResponse.data?.presses?.data.slice(0, 10).map(sanitize) || []; 
        slider = sliderResponse?.data?.homeSlider?.data?.attributes?.Projects || [];
        clients = clientResponse.data?.clients?.data.slice(0, 10).map(sanitize) || [];
        homeText = homeTextResponse?.data?.headerAndTexts?.data?.[0]?.attributes || {};
    } catch (err) {
        console.error("Error fetching data:", err);
    }

    return {
        props: {
            press,
            clients,
            slider,
            homeText,
        },
        revalidate: 604800,
    };
}

